import 'core-js/stable'
import 'regenerator-runtime/runtime'

import { StrictMode } from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'

import { createStore } from './store'
import { configureApi } from './api'

import './styles/index.scss'

import App from './App'

const store = createStore()
configureApi(store.dispatch, store.getState)

const Main = () => {
  return (
    <StrictMode>
      <Provider store={store}>
        <App />
      </Provider>
    </StrictMode>
  )
}

const rootEl = document.getElementById('__root')

render(<Main />, rootEl)
